import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const postGenerateCostReport = async (
  projectId,
  { recordsFromDate, recordsToDate, invoicesFromDate, invoicesToDate }
) => {
  const apiPath = `report/${projectId}/generate-cost-report`;

  const body = {
    recordsFromDate,
    recordsToDate,
    invoicesFromDate,
    invoicesToDate,
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
